import { render, staticRenderFns } from "./imagePreview.vue?vue&type=template&id=4c4dc1a5&"
import script from "./imagePreview.vue?vue&type=script&lang=js&"
export * from "./imagePreview.vue?vue&type=script&lang=js&"
import style0 from "./imagePreview.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=less&slot-scope=scope&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports